<template>
  <l-popup>
    <b-row>
      <b-col cols="12">
        <b>Model:</b><span class="bigger-font"> {{ data.model }}</span>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12">
        <b>Reference:</b><span class="bigger-font"> {{ data.reference }}</span>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12">
        <b>Type:</b><span class="bigger-font"> {{ data.type }}</span>
      </b-col>
    </b-row>
  </l-popup>
</template>

<script>
import { mapGetters } from 'vuex';
import { LPopup } from 'vue2-leaflet';
import 'leaflet/dist/leaflet.css';

export default {
  name: 'Popup',
  props: {
    data: {
      type: Object,
      required: false,
      default: () => ({
        model: 'Unknown',
        reference: 'Unknown',
        type: 'Unknown'
      })
    }
  },
  components: {
    LPopup
  }
};
</script>
